import React, { useEffect, useState } from "react";
import AsyncSelect, { SelectAsyncOptionType } from "react-select/async";

const DefaultOption = {
	value: "0",
	label: "Tất cả",
	object: null,
};

const customStyles = {
	singleValue: (provided?: any | null, state?: any | null) => ({
		...provided,
		color: "var(--text-color0)",
	}),
	valueContainer: (provided?: any | null, state?: any | null) => ({
		...provided,
		padding: "12px 20px 12px 20px",
		fontFamily: "BeVietnamPro",
		fontStyle: "normal",
		fontWeight: "600",
		fontSize: "14px",
		lineHeight: "19px",
		color: "var(--text-color0)",
		height: "55px",
		"@media screen and (max-width: 768px)": {
			padding: "11px 20px 11px 20px",
			height: "45px",
		},
	}),
	control: (provided?: any | null, state?: any | null) => ({
		...provided,
		border: "1px solid var(--border-color)",
		fontSize: "14px",
		borderRadius: "100px",
	}),
};

const smStyles = {
	singleValue: customStyles.singleValue,
	valueContainer: (provided?: any | null, state?: any | null) => ({
		...customStyles.valueContainer(provided, state),
		fontWeight: "normal",
		padding: "6px 15px 6px 15px",
		height: "35px",
	}),
	control: customStyles.control,
};

const xsStylesResponsive = {
	singleValue: smStyles.singleValue,
	valueContainer: (provided?: any | null, state?: any | null) => ({
		...smStyles.valueContainer(provided, state),
		"@media screen and (max-width: 768px)": {
			padding: "4px 15px 4px 15px",
			height: "30px",
		},
	}),
	control: (provided?: any | null, state?: any | null) => ({
		...smStyles.control(provided, state),
		"@media screen and (max-width: 768px)": {
			minHeight: "32px",
		},
	}),

	dropdownIndicator: (provided?: any | null, state?: any | null) => ({
		...provided,
		"@media screen and (max-width: 768px)": {
			padding: "5px",
		},
	}),
};

const smStylesResponsive = {
	singleValue: smStyles.singleValue,
	valueContainer: (provided?: any | null, state?: any | null) => ({
		...smStyles.valueContainer(provided, state),
		"@media screen and (max-width: 768px)": {
			padding: "6px 15px 6px 15px",
			height: "35px",
		},
	}),
	control: smStyles.control,
};

export function SmSelectAsyncSearchBox(props: {
	className?: string;
	selectedId?: string | number;
	defaultSelectedOption?: SelectAsyncOptionType;
	onChange?: (val: string | number, item: SelectAsyncOptionType) => void;
	responsive?: boolean;
	extraSmall?: boolean;
	loadOptionPromise?: (input: string, setOpts: (opts: SelectAsyncOptionType[]) => void) => void;
}) {
	const [options, setOptions] = useState<SelectAsyncOptionType[]>([DefaultOption]);
	const [selected, setSelected] = useState<SelectAsyncOptionType | null>();

	const loadOptions = (inputValue: string) => props.loadOptionPromise?.(inputValue, setOptions);

	const onSelectChange = (item: any) => {
		const selectedValue = item?.value;
		if (selectedValue === DefaultOption.value || selectedValue === "" || selectedValue === 0 || selectedValue === "0") {
			props.onChange?.("", DefaultOption);
		} else {
			props.onChange?.(item?.value, item);
		}
	};

	const autoSelect = () => {
		if (!props.selectedId) {
			setSelected(DefaultOption);
			return;
		}

		var find = options.find((item) => item.value?.toString() === props.selectedId?.toString());
		if (find) setSelected(find);
		else if (props.defaultSelectedOption?.value?.toString() === props.selectedId?.toString()) {
			setSelected(props.defaultSelectedOption);
		} else setSelected(null);
	};

	useEffect(() => {
		autoSelect();
	}, [props.selectedId, options, props.defaultSelectedOption]);

	return (
		<AsyncSelect
			{...props}
			styles={props.responsive ? (props.extraSmall ? xsStylesResponsive : smStylesResponsive) : smStyles}
			value={(selected && selected) || undefined}
			loadOptions={loadOptions}
			defaultOptions
			onChange={onSelectChange}
			noOptionsMessage={() => "No data displayed"}
		/>
	);
}
